import React, { useState, useEffect } from 'react'
import { Global } from '@emotion/react/macro'
import { useRedirect, useRoutes, navigate } from '@patched/hookrouter'
import { getIdToken, getCurrentUserId } from './api/auth-service'
import { isOpsTeam } from './api/employee-service'
import { NotFound } from './common/components'
import { Toaster } from '@/common/components/ui/sonner'
import router, { routes } from './router'
import globalStyle from './global-style'

function handleRedirection(currentPath) {
  const
    hasAccessToken = !!getIdToken(),
    isHealthCheckPath = currentPath === routes.health,
    isSignUpPath = currentPath === routes.signUp,
    isLoginPath = currentPath === routes.login,
    isResetPath = currentPath === routes.reset

  if (isHealthCheckPath)
    return null

  if (hasAccessToken && (isLoginPath || isSignUpPath || isResetPath)) 
    navigate(routes.seatMap, true)
  
  if (!hasAccessToken && !(isLoginPath || isSignUpPath || isResetPath))
    navigate(routes.login, true)

}

function App() {
  const currentPath = window.location.pathname
  useRedirect('/dashboard', '/')
  handleRedirection(currentPath)

  const
    [isInOps, setIsInOps] = useState(false),
    resultRoute = useRoutes(router),
    hasPath = currentPath === '/dashboard' || Object.values(routes).includes(currentPath)

  useEffect(() => {
    const isAuthOrPublicPath =
      currentPath === routes.login ||
      currentPath === routes.signUp ||
      currentPath === routes.reset ||
      currentPath === routes.health

    const token = getIdToken()
    const userId = getCurrentUserId()

    if (isAuthOrPublicPath || !token || !userId) {
      setIsInOps(false)
      return
    }

    isOpsTeam(userId).then(setIsInOps).catch(() => setIsInOps(false))
  }, [currentPath])
  
  return !hasPath ? <NotFound /> : (
    <React.StrictMode>
      <Global styles={globalStyle} />
      {resultRoute?.(isInOps)}
      <Toaster />
    </React.StrictMode>
  )
}

export default App
